import { render } from "./modalRelationStore.vue?vue&type=template&id=233316a6&scoped=true&ts=true"
import script from "./modalRelationStore.vue?vue&type=script&lang=ts"
export * from "./modalRelationStore.vue?vue&type=script&lang=ts"

import "./modalRelationStore.vue?vue&type=style&index=0&id=233316a6&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233316a6"]])

export default __exports__